import styled from 'styled-components';
import { Box, Typography, Card } from 'components/ui';
import theme from 'theme';

export const PricingCard = styled(Card).attrs(({ $highlighted: _h, ...props }) => props)`
  height: 100%;
  border-radius: 16px;
  border: ${({ $highlighted }) =>
    $highlighted ? `2px solid ${theme.palette.primary.main}` : '1px solid #dfe8e3'};
  position: relative;
  overflow: visible;
  transition: all 0.3s;

  &.shadow {
    box-shadow: ${({ $highlighted }) =>
      $highlighted
        ? `0 24px 48px ${theme.palette.custom.darkGreen}`
        : `0 14px 28px ${theme.palette.custom.darkGreen}`};

    &:hover {
      box-shadow: 0 28px 56px ${theme.palette.custom.darkGreen};
    }
  }
`;

export const PricingBadge = styled(Box)`
  position: absolute;
  top: -14px;
  left: 50%;
  transform: translateX(-50%);
  background-color: ${theme.palette.primary.main};
  color: white;
  padding: 4px 20px;
  border-radius: 20px;
  font-size: ${theme.typography.fontSizeSmall}px;
  font-weight: 700;
  white-space: nowrap;
`;

export const PricingPrice = styled(Typography)`
  font-weight: 800;
  color: #18221d;
  font-size: ${theme.typography.fontSizeMedium}px;
  line-height: 1;
`;

export const PricingPeriod = styled.span`
  font-size: ${theme.typography.fontSize}px;
  display: inline-block;
`;

export const PricingFeatureList = styled(Box)`
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin: 24px 0 32px;
`;

export const PricingFeatureItem = styled(Box)`
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: ${theme.typography.fontSizeSmall}px;
`;
